import React from 'react';
import { RouteProps } from 'react-router-dom';
import { demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';
import ClerkAside from '../pages/_layout/_asides/ClerkAside';
import ProtectedRoute from './ProtectedRoute';

const asides: RouteProps[] = [
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.signUp.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },

	{
		path: '/clerk/dashboard',
		element: <ProtectedRoute roles={['clerk']} element={<ClerkAside />} />,
	},
	{ path: '*', element: <ProtectedRoute roles={['admin']} element={<DefaultAside />} /> },
];

export default asides;
